const sales = {
  en: {
    subtitle: 'Revenue, orders and your top courses',
    exportCsv: 'Export CSV',
    exportFailed: 'Could not export the CSV file',
    kpiRevenue: 'Total revenue',
    revenueTrend: 'Revenue trend',
    revenueTrendSub: 'Completed sales, UZS',
    revenueSeriesName: 'Revenue',
    periodTotal: 'Past {period}: {amount}',
    topCourses: 'Top courses',
    topCoursesSub: 'By revenue',
    statusBreakdown: 'Order status',
    statusBreakdownSub: 'Distribution across all orders',
    ordersHeading: 'All orders',
    noRevenueTitle: 'No revenue in this period',
    noRevenueHint: 'Pick another period or wait for new orders.',
    noCourses: 'No course revenue yet',
    kpiRevenueSub: 'from completed orders',
    kpiOrdersSub: 'all time',
    kpiAvgSub: 'per completed order',
    paidRate: 'paid rate',
    period7d: '7 days',
    period30d: '30 days',
    period90d: '90 days',
    period1y: '1 year',
    periodAria: 'Period',
    searchPlaceholder: 'Search customer or course...',
    statusFilterAria: 'Filter by status',
    sortLabel: 'Sort by',
    sortDateDesc: 'Newest first',
    sortDateAsc: 'Oldest first',
    sortAmountDesc: 'Largest amount',
    sortAmountAsc: 'Smallest amount',
    sortCustomerAsc: 'Customer (A–Z)',
  },
  ru: {
    subtitle: 'Выручка, заказы и лучшие курсы',
    exportCsv: 'Экспорт CSV',
    exportFailed: 'Не удалось выгрузить CSV-файл',
    kpiRevenue: 'Общая выручка',
    revenueTrend: 'Динамика выручки',
    revenueTrendSub: 'Завершённые продажи, сум',
    revenueSeriesName: 'Выручка',
    periodTotal: 'За {period}: {amount}',
    topCourses: 'Топ курсов',
    topCoursesSub: 'По выручке',
    statusBreakdown: 'Статусы заказов',
    statusBreakdownSub: 'Распределение по всем заказам',
    ordersHeading: 'Все заказы',
    noRevenueTitle: 'За этот период выручки нет',
    noRevenueHint: 'Выберите другой период или дождитесь новых заказов.',
    noCourses: 'Пока нет выручки по курсам',
    kpiRevenueSub: 'из завершённых заказов',
    kpiOrdersSub: 'за всё время',
    kpiAvgSub: 'на завершённый заказ',
    paidRate: 'доля оплат',
    period7d: '7 дней',
    period30d: '30 дней',
    period90d: '90 дней',
    period1y: '1 год',
    periodAria: 'Период',
    searchPlaceholder: 'Клиент или курс...',
    statusFilterAria: 'Фильтр по статусу',
    sortLabel: 'Сортировка',
    sortDateDesc: 'Сначала новые',
    sortDateAsc: 'Сначала старые',
    sortAmountDesc: 'Сначала крупные суммы',
    sortAmountAsc: 'Сначала мелкие суммы',
    sortCustomerAsc: 'Клиент (А–Я)',
  },
  uz: {
    subtitle: 'Daromad, buyurtmalar va eng yaxshi kurslar',
    exportCsv: 'CSV yuklab olish',
    exportFailed: "CSV faylni yuklab bo'lmadi",
    kpiRevenue: 'Jami daromad',
    revenueTrend: 'Daromad dinamikasi',
    revenueTrendSub: "Yakunlangan sotuvlar, so'm",
    revenueSeriesName: 'Daromad',
    periodTotal: "So'nggi {period} ichida: {amount}",
    topCourses: 'Top kurslar',
    topCoursesSub: "Daromad bo'yicha",
    statusBreakdown: 'Buyurtma holatlari',
    statusBreakdownSub: "Barcha buyurtmalar bo'yicha taqsimot",
    ordersHeading: 'Barcha buyurtmalar',
    noRevenueTitle: "Bu davrda daromad yo'q",
    noRevenueHint: 'Boshqa davrni tanlang yoki yangi buyurtmalarni kuting.',
    noCourses: "Hali kurs daromadi yo'q",
    kpiRevenueSub: 'yakunlangan buyurtmalardan',
    kpiOrdersSub: 'butun davr',
    kpiAvgSub: 'har bir yakunlangan buyurtmaga',
    paidRate: "to'lov ulushi",
    period7d: '7 kun',
    period30d: '30 kun',
    period90d: '90 kun',
    period1y: '1 yil',
    periodAria: 'Davr',
    searchPlaceholder: 'Mijoz yoki kurs qidirish...',
    statusFilterAria: "Holat bo'yicha filtr",
    sortLabel: 'Saralash',
    sortDateDesc: 'Yangilari avval',
    sortDateAsc: 'Eskilari avval',
    sortAmountDesc: 'Eng katta summa',
    sortAmountAsc: 'Eng kichik summa',
    sortCustomerAsc: 'Mijoz (A–Z)',
  },
};

export default sales;
